export default "__VITE_ASSET__DQRtaeZA__"